import React, { memo } from 'react';
import styled from 'styled-components';
import { mediumMediaQuery, largeMediaQuery } from '../../common/utilities/sizeHelpers';
import { FooterDevicesSection } from './footerSections/devicesSection/footerDevicesSection';
import { FooterSocialSection } from './footerSections/socialSection/footerSocialSection';
import { FooterColophonSection } from './footerSections/colophonSection/footerColophonSection';
import { FooterPrivacySection } from './footerSections/privacySection/FooterPrivacySection';

export const FooterWrapper = memo(() =>
{
    return (
        <FooterSectionContainer>
            <FooterSectionDevicesWrapper key='device_screen_section_wrapper'>
                <FooterSectionsWrapper key='screen_container_wrapper'>
                    <FooterDevicesSection />
                </FooterSectionsWrapper>
            </FooterSectionDevicesWrapper>
            <FooterSectionBottomWrapper isSocial={true} key='social_screen_section_wrapper'>
                <FooterSectionsWrapper key='social_container_wrapper'>
                    <FooterSocialSection />
                </FooterSectionsWrapper>
            </FooterSectionBottomWrapper>
            <FooterSectionBottomWrapper key='colophon_privacy_sections_wrapper'>
                <FooterSectionsWrapper key='colophon_privacy_container_wrapper'>
                    <FooterColophonSection />
                </FooterSectionsWrapper>
            </FooterSectionBottomWrapper>
        </FooterSectionContainer>
    );
});

FooterWrapper.displayName = 'FooterWrapper';

const FooterSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    background-color: #2f6f8c;
`;

const FooterSectionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 9px;
    @media ${largeMediaQuery} {
        max-width: calc(1218px + 8%);
        padding-left: 4%;
        padding-right: 4%;
    }
    @media ${mediumMediaQuery} {
        padding-left: 15px;
        padding-right: 15px;
    }
`;

const FooterSectionDevicesWrapper = styled.div`
    display: flex;
    width: 100%;
    background-color: #ffffff;
`;

interface FooterSectionBottomWrapperProps {
    isSocial?: boolean;
}
const FooterSectionBottomWrapper = styled.div<FooterSectionBottomWrapperProps>`
    display: flex;
    width: 100%;
    ${({ isSocial }) => isSocial && 'border-bottom: 1px solid #0B2E4D'};
    position: relative;
`;